// Phone lookup constants
export const PHONE_LOOKUP_REQUEST = 'PHONE_LOOKUP_REQUEST';
export const PHONE_LOOKUP_SUCCESS = 'PHONE_LOOKUP_SUCCESS';
export const PHONE_LOOKUP_FAIL = 'PHONE_LOOKUP_FAIL';
export const PHONE_LOOKUP_RESET = 'PHONE_LOOKUP_RESET';

// Virtual QR payment constants
export const VIRTUAL_QR_PAYMENT_REQUEST = 'VIRTUAL_QR_PAYMENT_REQUEST';
export const VIRTUAL_QR_PAYMENT_SUCCESS = 'VIRTUAL_QR_PAYMENT_SUCCESS';
export const VIRTUAL_QR_PAYMENT_FAIL = 'VIRTUAL_QR_PAYMENT_FAIL';
export const VIRTUAL_QR_PAYMENT_RESET = 'VIRTUAL_QR_PAYMENT_RESET';

// Virtual QR payment verification constants
export const VIRTUAL_QR_VERIFY_REQUEST = 'VIRTUAL_QR_VERIFY_REQUEST';
export const VIRTUAL_QR_VERIFY_SUCCESS = 'VIRTUAL_QR_VERIFY_SUCCESS';
export const VIRTUAL_QR_VERIFY_FAIL = 'VIRTUAL_QR_VERIFY_FAIL';
export const VIRTUAL_QR_VERIFY_RESET = 'VIRTUAL_QR_VERIFY_RESET';